// extracted by mini-css-extract-plugin
export var form = "_dp-0";